import React from 'react';
import { AccordionPanel, Box, HStack, Td, Text, Tooltip, Tr, } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { localise, pluralise } from '../../../services/lang/lang';
import { DEFAULT_VALUE } from '../../../services/text/optionalValue';
import { RenderIf } from '../RenderIf/RenderIf';
import { setHazard } from '../../../actions/hazardsDefects';
import { useTokens } from '../../../context/TokenProvider';
import HazardFindingsWrapper from '../FindingsWrapper/HazardFindingsWrapper';
import ExpandableTableRow from '../Table/ExpandableTableRow';
import AlertIcon from '../../icons/AlertIcon';
import { getNationalAverages } from '../../../actions/editScoring';
import TableRowEditButton from '../SurveyFindings/TableRowEditButton';
import { makeMed4 } from '../../../styles/textStyles';
import RenderIfElse from '../RenderIf/RenderIfElse';
import HazardFindingsShareWrapper from '../FindingsWrapper/Share/HazardFindingsShareWrapper';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import TableAccordionButton from '../Table/TableAccordionButton';
const HazardFindingsTableRow = ({ data, onScoringOpen, isExpanded, onRowClick, canEdit, inspection, }) => {
    const { isShare } = useInspectionDetailContext();
    const dispatch = useDispatch();
    const tokens = useTokens();
    if (!data)
        return null;
    const band = data.scoring?.band
        ? `${localise('BAND')} ${data.scoring.band}`
        : localise('INCOMPLETE');
    const category = data.scoring?.category
        ? `${localise('CATEGORY')} ${data.scoring.category}`
        : DEFAULT_VALUE;
    const score = data.scoring?.score
        ? (+data.scoring.score).toFixed(1)
        : DEFAULT_VALUE;
    const handleScoringButtonClicked = (event) => {
        event.stopPropagation();
        onScoringOpen(data);
        dispatch(setHazard(data));
        dispatch(getNationalAverages(inspection, data));
    };
    const showRescoreWarning = data.scoring?.requires_rescore === true && !isShare && !!canEdit;
    return (React.createElement(React.Fragment, null,
        React.createElement(ExpandableTableRow, { isExpanded: isExpanded, "data-testid": "hazard-findings_table_row_row", onClick: onRowClick },
            React.createElement(TableAccordionButton, { isExpanded: isExpanded }),
            React.createElement(Td, { "data-testid": "hazard-findings_table_row__name" }, data.name),
            React.createElement(Td, { maxW: "110px", "data-testid": "hazard-findings_table_row__findings" }, `${data.findings_count} ${pluralise(localise('FINDING'), data.findings_count)}`),
            React.createElement(Td, { "data-testid": "hazard-findings_table_row__score" }, score),
            React.createElement(Td, { "data-testid": "hazard-findings_table_row__band" }, band),
            React.createElement(Td, { "data-testid": "hazard-findings_table_row__category" }, category),
            React.createElement(Td, { w: "115px", align: "right" },
                React.createElement(HStack, null,
                    React.createElement(TableRowEditButton, { canEdit: !!canEdit, onClick: handleScoringButtonClicked, "data-testid": "hazard-findings_table_row__scoring-button" },
                        React.createElement(Text, { sx: makeMed4(tokens) }, localise('SCORING'))),
                    React.createElement(RenderIf, { condition: showRescoreWarning },
                        React.createElement(Tooltip, { "aria-label": localise('RESCORE_REQUIRED_EXPLANATION'), label: localise('RESCORE_REQUIRED_EXPLANATION') },
                            React.createElement(Box, { "data-testid": "hazard-findings-table-row__rescore-icon" },
                                React.createElement(AlertIcon, { fill: tokens.IconError }))))))),
        React.createElement(AccordionPanel, { as: Tr, bgColor: tokens.Layer01, overflowY: "auto", overflowX: "hidden" },
            React.createElement(Td, { colSpan: 7 },
                React.createElement(RenderIfElse, { condition: !!isShare, then: React.createElement(HazardFindingsShareWrapper, { isExpanded: isExpanded, hazard: data }), else: React.createElement(HazardFindingsWrapper, { isExpanded: isExpanded, hazard: data, inspectionId: inspection.id }) })))));
};
export default HazardFindingsTableRow;
